export enum ASSETS_AND_LIABILITIES_DIALOG_STEPS_LABELS {
  'Statement of assets & liabilities',
  Assets,
  Liabilities,
  'Income information',
  Review,
  Sign,
}

export {
  BALANCE_SHEET_DOCUMENTS_TAGS,
  BANK_ACCOUNT_STATEMENT_STATUS,
  BANK_STATEMENT_DOCUMENTS_TAGS,
  CHARGE_TEMPLATE_ID,
  DOCUMENT_STATUS,
  FILLABLE_DOCUMENTS_TEMPLATE_IDS,
  FINANCIAL_FILES_TAG,
  GENERATE_MISSING_DOCUMENTS,
  GUARANTEE_UNDERTAKING_TEMPLATE_ID,
  LIABILITY_DOCUMENTS_TEMPLATE_IDS,
  PERSONAL_LIABILITY_TEMPLATE_ID,
  PROFIT_AND_LOSS_DOCUMENTS_TAGS,
  STATEMENT_OF_ASSETS_LIABILITIES_TEMPLATE_ID,
  SUPPORTING_FILES_DOCUMENTS_TAGS,
} from '@treyd-io/shared/constants/documents';
